import { DrilldownRolodexType } from 'features/drilldown/rolodex/ontology/ontologyTypes'
import CantileverTheme from 'styles/cantileverTheme'
import {
  GeckoComponentModelType,
  RolodexHistogramFilter,
  RolodexHistogramFilterOp,
} from 'types'

import { PaginatedRolodexTableProps } from './PaginatedRolodexTable'

export const COMPONENT_TYPE_COLORS: Record<GeckoComponentModelType, string> = {
  [GeckoComponentModelType.VerticalTankShell]:
    CantileverTheme.colors.DeepSeaBlue,
  [GeckoComponentModelType.TankFloor]: CantileverTheme.colors.Vermilion,
  [GeckoComponentModelType.TankFlatRoof]: CantileverTheme.colors.Turquoise,
  [GeckoComponentModelType.HorizontalTankShell]:
    CantileverTheme.colors.LightSkyBlue,
  [GeckoComponentModelType.PipeSection]: CantileverTheme.colors.Turquoise,
  [GeckoComponentModelType.LegacyBoilerWalls]: CantileverTheme.colors.OceanBlue,
  [GeckoComponentModelType.ShipDeck]: CantileverTheme.colors.SeaGreen,
  [GeckoComponentModelType.BasicShipHull]: CantileverTheme.colors.SkyBlue,
  [GeckoComponentModelType.LegacyCone]: CantileverTheme.colors.Tangerine,
  [GeckoComponentModelType.Cone]: CantileverTheme.colors.Tangerine,
  [GeckoComponentModelType.LaunchTube]: CantileverTheme.colors.Teal,
  [GeckoComponentModelType.Dome]: CantileverTheme.colors.Turquoise,
  [GeckoComponentModelType.DomeWall]: CantileverTheme.colors.Turquoise,
  [GeckoComponentModelType.FlatCircularFloor]: CantileverTheme.colors.Turquoise,
  [GeckoComponentModelType.VerticalTankFoundation]:
    CantileverTheme.colors.Turquoise,
  [GeckoComponentModelType.MachinedForgingSimple]:
    CantileverTheme.colors.LemonYellow,
  [GeckoComponentModelType.PressureVesselShell]:
    CantileverTheme.colors.BrightOrange,
  [GeckoComponentModelType.HemisphericalHead]:
    CantileverTheme.colors.BrightOrange,
  [GeckoComponentModelType.TorisphericalHead]:
    CantileverTheme.colors.BrightOrange,
  [GeckoComponentModelType.EllipsoidalHead]:
    CantileverTheme.colors.BrightOrange,
}

export const ID_SORT_KEYS: PaginatedRolodexTableProps['sortKeys'] = {
  id: { field: 'id' },
}

export const ID_AND_NAME_SORT_KEYS: PaginatedRolodexTableProps['sortKeys'] = {
  id: { field: 'id' },
  name: { field: 'data', key: 'name' },
}

export const ID_AND_NAME_FILTER_KEYS: PaginatedRolodexTableProps['filterKeys'] =
  {
    id: { field: 'id' },
    name: { field: 'data', key: 'name' },
  }

export function createTableFilters(
  filterValues: ReadonlyMap<string, string>,
  filterKeys: Record<string, { field?: string; key?: string; type?: string }>,
  fallbackType?: DrilldownRolodexType
): ReadonlyArray<RolodexHistogramFilter> {
  return [
    ...filterValues
      .entries()
      .map(([key, value]) => {
        const filterKey = filterKeys?.[key]
        if (!filterKey) {
          return null
        }
        return {
          ...filterKey,
          op: '~' as RolodexHistogramFilterOp,
          value,
          type: filterKey.type ?? fallbackType,
        }
      })
      .filter((item): item is NonNullable<typeof item> => item !== null),
  ]
}
